import { Config } from '../application-config';

export interface URLTarget {
  path: string;
  ids?: string | Object;
}

export class URLCreator {
  readonly proxyTarget: string;

  constructor({ proxyTarget }: Config) {
    this.proxyTarget = proxyTarget;
  }

  createUrl(target: URLTarget): string {
    let url = this.proxyTarget + target.path;

    if (target.ids) {
      let idObject = typeof target.ids === 'object' ? target.ids : { id: target.ids };
      Object.keys(idObject).forEach((key) => {
        const value = Reflect.get(idObject, key);
        if (value == null) {
          throw new Error(`Missing required URL parameter: ${key}`);
        }
        url = url.replace(`:${key}`, value);
      });
    }

    return url;
  }
}
